import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import { State as RouterState } from 'router';
import { reducer as assetsReducer, State as AssetsState } from 'sections/assets';
import { reducer as campaignsReducer, State as CampaignsState } from 'sections/campaigns';
import { reducer as clientsReducer, State as ClientsState } from 'sections/client-management';
import { dataReducer, DataState } from '../services';
import { uiReducer, UIState } from '../core/ui';

// Global state interface
export interface State {
  assets: AssetsState;
  campaigns: CampaignsState;
  clients: ClientsState;
  data: DataState;
  router: RouterState;
  ui: UIState;
}

export const reducer = (history: any) =>
  combineReducers<State>({
    assets: assetsReducer,
    campaigns: campaignsReducer,
    clients: clientsReducer,
    data: dataReducer,
    router: connectRouter(history),
    ui: uiReducer,
  });
